import { Blacklist } from "../types/blacklist";
import api from "./api";

export const listBlacklistEmail = async (to?: string): Promise<Blacklist[]> => {
  const response = await api.get("report-:stage/blacklist/email", {
    params: { to },
  });

  return response.data.content;
};

export const listBlacklistSms = async (to?: string): Promise<Blacklist[]> => {
  const response = await api.get("report-:stage/blacklist/sms", {
    params: { to },
  });

  return response.data.content;
};
